import React from 'react';
import FontAwesome from 'react-fontawesome';
import { Nav, Navbar, NavItem, Button, InputGroup, FormControl } from 'react-bootstrap';
import FilterBar from 'components/core/FilterBar';
import Select from 'components/core/Select'

const GlossaryListFilter = (props) => {

  const {
    keyword,
    category,
    options,
    handleSubmit,
    handleKeywordChange,
    handleCategoryChange
  } = props;

  return (
    <FilterBar>
      <Nav>
        <NavItem disabled>Category</NavItem>
      </Nav>
      <Navbar.Form pullLeft>
        <Select
          value={category}
          clearable={true}
          options={options}
          placeholder=""
          onChange={value => handleCategoryChange(value)}
          style={{ width: 200 }} />
      </Navbar.Form>
      <Navbar.Form pullRight>
        <InputGroup bsSize="sm">
          <FormControl
            value={keyword}
            onChange={(e) => handleKeywordChange(e.target.value)}
            onKeyPress={(e) => {
              e.key === 'Enter' && handleSubmit()
            }}
            type="text"
            style={{ width: 200 }}
            bsSize="sm" />
          <InputGroup.Button>
            <Button
              bsSize="sm"
              onClick={handleSubmit}>
              <FontAwesome name="search" />
            </Button>
          </InputGroup.Button>
        </InputGroup>
      </Navbar.Form>
    </FilterBar>
  );
}

export default GlossaryListFilter;
